import { type TreeRow } from './types';

export function isTreeRow<Attributes = unknown>(data: unknown): data is TreeRow<Attributes> {
    return (
        typeof data === 'object' &&
        data !== null &&
        'id' in data &&
        'parentId' in data &&
        'attributes' in data &&
        'level' in data &&
        'isLastInParent' in data &&
        'hasChildren' in data &&
        'rendersBefore' in data &&
        'childrenIds' in data
    );
}
